export { default } from './IconWrapper';